import { Snackbar } from "@mui/material";
import { format } from "date-fns";
import { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import storageService from "../../services/storage/storage-service/StorageService";

// NOTE: This component is based on this article: https://felixgerschau.com/create-a-pwa-update-notification-with-create-react-app/
// Additional reading:
// https://whatwebcando.today/articles/handling-service-worker-updates
// https://web.dev/service-worker-lifecycle/

export default function ServiceWorkerManager() {
    const [showUpdated, setShowUpdated] = useState(storageService.session.get("showSWUpdated", false));
    const [serviceWorkerRegistration, setServiceWorkerRegistration] = useState<ServiceWorkerRegistration | null>(null);
    const {t} = useTranslation();

    useEffect(() => {

        //https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerRegistration/updatefound_event
        //https://whatwebcando.today/articles/handling-service-worker-updates/
        const watchForUpdate = async () => {

            const registration = await navigator.serviceWorker.getRegistration();
            if (registration) {

                // ensure the case when the updatefound event was missed is also handled
                // by re-invoking the prompt when there's a waiting Service Worker
                if (registration.waiting) {
                    console.log('update found event missed and there is update available');
                    onSWUpdate(registration);
                }

                // detect Service Worker update available and wait for it to become installed
                registration.addEventListener('updatefound', () => {
                    console.log('Service Worker update found!');

                    if (registration.installing) {
                        console.log('service worker installing');

                        // wait until the new Service worker is actually installed (ready to take over)
                        registration.installing.addEventListener('statechange', () => {

                            if (registration.waiting) {
                                // if there's an existing controller (previous Service Worker), show the prompt
                                if (navigator.serviceWorker.controller) {
                                    console.log('do the update now')
                                    onSWUpdate(registration);
                                } else {
                                    // otherwise it's the first install, nothing to do
                                    console.log('Service Worker initialized for the first time')
                                }
                            }
                        });
                    }
                });
            }
        };

        watchForUpdate();

        let reloading = false;
        navigator.serviceWorker.addEventListener('controllerchange', () => {

            if (!reloading) {
                console.log('service worker reloading app now')
                reloading = true;
                window.location.reload();
            }
        });
    }, []);

    useEffect(() => {
        async function setRegistration() {
            const registration = await navigator.serviceWorker.getRegistration();
            if (registration) {
                setServiceWorkerRegistration(registration);
            }
        }

        setRegistration();
        // we need the onRegister callback to tell the service worker to check for 
        // an update when the user navigates to another view
        // serviceWorker.register({
        //     onRegister: onSWRegister 
        // });
    }, []);

    function onSWUpdate(registration: ServiceWorkerRegistration) {
        console.log(`sw onupdate called at ${format(new Date(), 'h:m:s:SSS')}`)
        storageService.session.set("showSWUpdated", "true");
        registration.waiting?.postMessage({ type: 'SKIP_WAITING' });
    };

    // function onSWRegister(registration: ServiceWorkerRegistration) {
    //     setServiceWorkerRegistration(registration);
    // };

    const location = useLocation();

    // use the complete url to determine checking for an update
    const currentUrl = `${location.pathname}${location.search}`;

    // This useEffect watches for changes in location path and triggers a check for
    // a service worker update. This functionality requires this component to be
    // located within the router component
    useEffect(() => {
        serviceWorkerRegistration?.update();
    }, [
        currentUrl,
        serviceWorkerRegistration
    ])

    useEffect(() => {
        // if the showUpdated state is true, then set a timer to dismiss it
        if(showUpdated)
        {
            setTimeout(() => {
                storageService.session.set("showSWUpdated", false);
                setShowUpdated(false);
            }, 5000);
        }
    }, [showUpdated])

    return (
        <Snackbar
            open={showUpdated}
            message={t("updatedAppMessage")}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            // action={
            //     <Button
            //         color="inherit"
            //         size="small"
            //         onClick={
            //             () => {
            //                 storageService.session.set("showSWUpdated", false);
            //                 setShowUpdated(false);
            //             }
            //         }
            //     >
            //         {t("buttons.dismiss")}
            //     </Button>
            // }
        />
    );
}

//////////////////////////////////////////////////////////////////////////////////
// Previous Update Prompt version (in case Product changes their minds...again)
//////////////////////////////////////////////////////////////////////////////////

// export default function ServiceWorkerManager() {
//     const [showReload, setShowReload] = useState(false);
//     const [waitingWorker, setWaitingWorker] = useState<ServiceWorker | null>(null);
//     const [serviceWorkerRegistration, setServiceWorkerRegistration] = useState<ServiceWorkerRegistration | null>(null);
//     const {t} = useTranslation();



//     useEffect(() => {

//         //https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerRegistration/updatefound_event
//         //https://whatwebcando.today/articles/handling-service-worker-updates/
//         const watchForUpdate = async () => {

//             const registration = await navigator.serviceWorker.getRegistration();
//             if (registration) {

//                 // ensure the case when the updatefound event was missed is also handled
//                 // by re-invoking the prompt when there's a waiting Service Worker
//                 if (registration.waiting) {
//                     console.log('update found event missed and there is update available');
//                     onSWUpdate(registration);
//                 }

//                 // detect Service Worker update available and wait for it to become installed
//                 registration.addEventListener('updatefound', () => {
//                     console.log('Service Worker update found!');

//                     if (registration.installing) {
//                     console.log('service worker installing');

//                     // wait until the new Service worker is actually installed (ready to take over)
//                     registration.installing.addEventListener('statechange', () => {

//                         if (registration.waiting) {
//                             // if there's an existing controller (previous Service Worker), show the prompt
//                             if (navigator.serviceWorker.controller) {
//                                 console.log('do the update now')
//                                 onSWUpdate(registration);
//                             } else {
//                                 // otherwise it's the first install, nothing to do
//                                 console.log('Service Worker initialized for the first time')
//                             }
//                         }
//                     });
//                     }
//                 });
//             }
//        };

//        watchForUpdate();


//         let reloading = false;
//         navigator.serviceWorker.addEventListener('controllerchange', () => {

//             if (!reloading) {
//                 console.log('service worker reloading app now')
//                 reloading = true;
//                 window.location.reload();
//             }
//         });
//     }, []);

//     useEffect(() => {

//         // we need the onRegister callback to tell the service worker to check for 
//         // an update when the user navigates to another view
//         serviceWorker.register({
//             //onUpdate: onSWUpdate,
//             onRegister: onSWRegister 
//         });
//     }, []);

//     function onSWUpdate(registration: ServiceWorkerRegistration) {
//         console.log(`sw onupdate called at ${format(new Date(), 'h:m:s:SSS')}`)
//         setShowReload(true);
//         setWaitingWorker(registration.waiting);
//     };

//     function onSWRegister(registration: ServiceWorkerRegistration) {
//         setServiceWorkerRegistration(registration);
//     };

//     function reloadPage() {
//         waitingWorker?.postMessage({ type: 'SKIP_WAITING' });
//         setShowReload(false);
//         //window.location.reload();
//     };

//     const location = useLocation();

//     // use the complete url to determine checking for an update
//     const currentUrl = `${location.pathname}${location.search}`;

//     // This useEffect watches for changes in location path and triggers a check for
//     // a service worker update. This functionality requires this component to be
//     // located within the router component
//     useEffect(() => {
//         serviceWorkerRegistration?.update();
//     }, [
//         //location.pathname, 
//         currentUrl,
//         serviceWorkerRegistration
//     ])

//     return (
//         <Snackbar
//             open={showReload}
//             message={t("updateAvailableMessage")}
//             anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
//             action={
//                 <Button
//                     color="inherit"
//                     size="small"
//                     onClick={reloadPage}
//                 >
//                     {t("update")}
//                 </Button>
//             }
//         />
       
//     );
// }